import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Import utilities
import LoadableMng from 'components/utilities/lodable_manager/LodableMng';

// Import components
import LoginContent from './LoginContent';
import { AuthenticationTemplate, LoginTemplate } from 'components/templates';

const LoginDevices = LoadableMng({
	func: () => import('../login/login_devices/LoginDevices')
});

const LoginAgreements = LoadableMng({
	func: () => import('./login_agreements/LoginAgreements')
});

const LoginMultipleAccount = LoadableMng({
	func: () => import('./login_multiple_account/LoginMultipleAccount')
});

const MultioperatorLogin = ({ isDeviceLimited, deviceExists, isAuthenticated, acceptedAgreements, isError, isMultipleAccount }) => {
	// Check if there is a device limit or device does not exists
	const checkDevices = isDeviceLimited || !deviceExists ? false : true;

	return (
		<AuthenticationTemplate>
			<LoginTemplate type="login">
				<LoginContent />

				{/* If user is authenticated and there is device limit or device does not exist show manage device panel */}
				{isAuthenticated && !checkDevices && !isError && <LoginDevices />}

				{/* If user is authenticated and there is not device limit and device exist but user has not accepted the agreements, show the modal with agreements */}
				{isAuthenticated && checkDevices && !acceptedAgreements && !isError && <LoginAgreements />}

				{isMultipleAccount && <LoginMultipleAccount />}
			</LoginTemplate>
		</AuthenticationTemplate>
	);
};

MultioperatorLogin.propTypes = {
	isDeviceLimited: PropTypes.bool.isRequired,
	deviceExists: PropTypes.bool.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
	acceptedAgreements: PropTypes.bool.isRequired,
	isError: PropTypes.bool.isRequired
};

const mapStateToProps = ({ auth }) => ({
	isDeviceLimited: auth.isDeviceLimited,
	deviceExists: auth.deviceExists,
	isAuthenticated: auth.isAuthenticated,
	acceptedAgreements: auth.acceptedAgreements,
	isError: auth.authError.isError,
	isMultipleAccount: auth?.multipleAccount?.isMultipleAccount
});

export default connect(mapStateToProps)(MultioperatorLogin);
